import _ from '../../core/utils'

const PASSWORD_CONFIG = {
    passwords: _.selectAll( '.input--password' )
}

export default PASSWORD_CONFIG